import './helpers/cookie';
import './components/cookiebar';
import './components/newsletter-modal';

const Granola = () => {
}

document.addEventListener('DOMContentLoaded', () => Granola());